// LUMINA · pages/AuthPages.jsx
// Auth-related page components: Login, Register, ForgotPassword, ResetPassword.

import React, { useState, useEffect } from 'react';
import { C, T, IS, LS, BG } from '../constants/baziData';

const API = "/api";
const GOOGLE_CLIENT_ID = "213851968461-nm8dc9ut7no26lpkb7f3ha4pkmu2ketj.apps.googleusercontent.com";

export function AuthCard({title,sub,children}){
  return(
    <div style={{
      minHeight:"calc(100vh - 60px)",
      display:"flex",alignItems:"center",justifyContent:"center",
      padding:"40px 20px",
      background:"radial-gradient(ellipse 90% 70% at 50% 0%,rgba(212,175,55,.08) 0%,rgba(6,78,59,.04) 50%,transparent 70%)",
    }}>
      <div style={{
        width:"100%",maxWidth:420,
        background:"rgba(255,255,255,.82)",
        backdropFilter:"blur(24px) saturate(1.4)",
        WebkitBackdropFilter:"blur(24px) saturate(1.4)",
        border:"1px solid rgba(255,255,255,.60)",
        borderRadius:20,padding:"36px 32px",
        boxShadow:"0 8px 48px rgba(0,0,0,.10),0 0 0 1px rgba(212,175,55,.12)",
      }}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:11,letterSpacing:".45em",color:"rgba(212,175,55,.65)",
            textTransform:"uppercase",marginBottom:10,
            fontFamily:"'Inter','Montserrat',sans-serif",fontStyle:"italic"}}>✦ &nbsp;LUMINA</div>
          <div style={{fontSize:24,color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",
            fontWeight:300,letterSpacing:".06em",marginBottom:6}}>{title}</div>
          {sub&&<div style={{fontSize:13,color:C.mist3,letterSpacing:".02em"}}>{sub}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

export function LoginPage({lang="en",setPage,onLogin}){
  const [f,setF]=useState({email:"",password:""});
  const [err,setErr]=useState(""); const [load,setLoad]=useState(false);
  const set=k=>e=>setF({...f,[k]:e.target.value});
  const submit=async()=>{
    setLoad(true);setErr("");
    try{
      const fd=new URLSearchParams();fd.append("username",f.email);fd.append("password",f.password);
      const r=await fetch(`${API}/auth/login`,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:fd});
      const d=await r.json();
      if(!r.ok)throw new Error(d.detail||"Login failed");
      localStorage.setItem("lumina_token",d.access_token);
      onLogin({email:d.email,tier:d.tier,is_admin:d.is_admin,token:d.access_token});
      setPage("audit");
    }catch(e){setErr(e.message);}
    setLoad(false);
  };
  useEffect(()=>{
    if(!GOOGLE_CLIENT_ID)return;
    const init=()=>{
      window.google.accounts.id.initialize({client_id:GOOGLE_CLIENT_ID,callback:async r=>{
        setLoad(true);setErr("");
        try{
          const res=await fetch(`${API}/auth/google`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({credential:r.credential})});
          const d=await res.json();
          if(!res.ok)throw new Error(d.detail||"Google login failed");
          localStorage.setItem("lumina_token",d.access_token);
          onLogin({email:d.email,tier:d.tier,is_admin:d.is_admin,token:d.access_token});
          setPage("audit");
        }catch(e){setErr(e.message);}
        setLoad(false);
      }});
      const el=document.getElementById("google-btn-login");
      if(el)window.google.accounts.id.renderButton(el,{theme:"outline",size:"large",width:300});
    };
    if(window.google?.accounts){init();return;}
    const s=document.createElement("script");
    s.src="https://accounts.google.com/gsi/client";s.async=true;s.onload=init;
    document.head.appendChild(s);
  },[]);
  return(
    <AuthCard title={T[lang].welcomeBack} sub={T[lang].loginSub}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div><span style={LS}>Email</span><input style={IS} type="email" value={f.email} onChange={set("email")} placeholder={T[lang].emailPlaceholder}/></div>
        <div><span style={LS}>Password</span><input style={IS} type="password" value={f.password} onChange={set("password")} placeholder="••••••••" onKeyDown={e=>e.key==="Enter"&&submit()}/></div>
        {err&&<div style={{fontSize:15,color:C.stress}}>{err}</div>}
        <button style={{...BG,opacity:load?0.6:1}} onClick={submit} disabled={load}>{load?T[lang].signingIn:T[lang].signInBtn}</button>
        <div style={{display:"flex",alignItems:"center",gap:8,margin:"2px 0"}}><div style={{flex:1,height:1,background:C.mist4}}/><span style={{fontSize:12,color:C.mist4,padding:"0 8px"}}>{lang==="zh"?"或":"or"}</span><div style={{flex:1,height:1,background:C.mist4}}/></div>
        <div id="google-btn-login" style={{display:"flex",justifyContent:"center",minHeight:44}}/>
        <div style={{textAlign:"center",fontSize:15,color:C.mist3}}>{T[lang].noAccount} <span style={{color:C.gold,cursor:"pointer"}} onClick={()=>setPage("register")}>{T[lang].registerFree}</span></div>
        <div style={{textAlign:"center",fontSize:13,color:C.mist4,marginTop:4}}><span style={{cursor:"pointer",textDecoration:"underline"}} onClick={()=>setPage("forgot-password")}>{lang==="zh"?"忘记密码？":"Forgot password?"}</span></div>
      </div>
    </AuthCard>
  );
}

export function RegisterPage({lang="en",setPage,onLogin}){
  const [f,setF]=useState({email:"",password:"",full_name:""});
  const [err,setErr]=useState(""); const [load,setLoad]=useState(false);
  const set=k=>e=>setF({...f,[k]:e.target.value});
  const submit=async()=>{
    if(f.password.length<8){setErr("Password must be at least 8 characters");return;}
    setLoad(true);setErr("");
    try{
      const r=await fetch(`${API}/auth/register`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(f)});
      const d=await r.json();
      if(!r.ok)throw new Error(d.detail||"Registration failed");
      const fd=new URLSearchParams();fd.append("username",f.email);fd.append("password",f.password);
      const lr=await fetch(`${API}/auth/login`,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:fd});
      const ld=await lr.json();
      localStorage.setItem("lumina_token",ld.access_token);
      onLogin({email:ld.email,tier:ld.tier,is_admin:ld.is_admin,token:ld.access_token});
      setPage("profile");
    }catch(e){setErr(e.message);}
    setLoad(false);
  };
  useEffect(()=>{
    if(!GOOGLE_CLIENT_ID)return;
    const init=()=>{
      window.google.accounts.id.initialize({client_id:GOOGLE_CLIENT_ID,callback:async r=>{
        setLoad(true);setErr("");
        try{
          const res=await fetch(`${API}/auth/google`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({credential:r.credential})});
          const d=await res.json();
          if(!res.ok)throw new Error(d.detail||"Google login failed");
          localStorage.setItem("lumina_token",d.access_token);
          onLogin({email:d.email,tier:d.tier,is_admin:d.is_admin,token:d.access_token});
          setPage("audit");
        }catch(e){setErr(e.message);}
        setLoad(false);
      }});
      const el=document.getElementById("google-btn-register");
      if(el)window.google.accounts.id.renderButton(el,{theme:"outline",size:"large",width:300});
    };
    if(window.google?.accounts){init();return;}
    const s=document.createElement("script");
    s.src="https://accounts.google.com/gsi/client";s.async=true;s.onload=init;
    document.head.appendChild(s);
  },[]);
  return(
    <AuthCard title={T[lang].createAccount} sub={T[lang].registerSub}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div><span style={LS}>Full Name</span><input style={IS} value={f.full_name} onChange={set("full_name")} placeholder={lang==="zh"?"您的姓名":"Your name"}/></div>
        <div><span style={LS}>Email</span><input style={IS} type="email" value={f.email} onChange={set("email")} placeholder="your@email.com"/></div>
        <div><span style={LS}>Password</span><input style={IS} type="password" value={f.password} onChange={set("password")} placeholder={T[lang].minPassword}/></div>
        {err&&<div style={{fontSize:15,color:C.stress}}>{err}</div>}
        <button style={{...BG,opacity:load?0.6:1}} onClick={submit} disabled={load}>{load?T[lang].creating:T[lang].createBtn}</button>
        <div style={{display:"flex",alignItems:"center",gap:8,margin:"2px 0"}}><div style={{flex:1,height:1,background:C.mist4}}/><span style={{fontSize:12,color:C.mist4,padding:"0 8px"}}>{lang==="zh"?"或":"or"}</span><div style={{flex:1,height:1,background:C.mist4}}/></div>
        <div id="google-btn-register" style={{display:"flex",justifyContent:"center",minHeight:44}}/>
        <div style={{textAlign:"center",fontSize:15,color:C.mist3}}>{T[lang].haveAccount} <span style={{color:C.gold,cursor:"pointer"}} onClick={()=>setPage("login")}>{T[lang].signIn}</span></div>
      </div>
    </AuthCard>
  );
}

// ── Profile page ──────────────────────────────────────────────────────────────

export function ForgotPasswordPage({lang="en",setPage}){
  const [email,setEmail]=useState("");
  const [sent,setSent]=useState(false);
  const [load,setLoad]=useState(false);
  const [err,setErr]=useState("");

  const submit=async()=>{
    if(!email){setErr(lang==="zh"?"请输入邮箱":"Please enter your email");return;}
    setLoad(true);setErr("");
    try{
      const r=await fetch(`${API}/auth/forgot-password`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email})
      });
      if(r.ok)setSent(true);
      else{const d=await r.json();setErr(d.detail||"Error");}
    }catch(e){setErr(e.message);}
    setLoad(false);
  };

  if(sent)return(
    <AuthCard title={lang==="zh"?"邮件已发送":"Email Sent"} sub="">
      <div style={{fontSize:15,color:C.sage,marginBottom:16}}>
        {lang==="zh"
          ?`如果 ${email} 存在账户，重置链接已发送到您的邮箱。请查看收件箱（或垃圾邮件文件夹）。`
          :`If an account exists for ${email}, a reset link has been sent. Check your inbox (and spam folder).`}
      </div>
      <div style={{fontSize:13,color:C.mist4,marginBottom:20}}>
        {lang==="zh"?"链接15分钟内有效。":"The link expires in 15 minutes."}
      </div>
      <button style={BG} onClick={()=>setPage("login")}>
        {lang==="zh"?"返回登录":"Back to Sign In"}
      </button>
    </AuthCard>
  );

  return(
    <AuthCard title={lang==="zh"?"忘记密码":"Forgot Password"} sub={lang==="zh"?"输入您的邮箱，我们将发送重置链接。":"Enter your email and we'll send you a reset link."}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div><span style={LS}>Email</span>
          <input style={IS} type="email" value={email} onChange={e=>setEmail(e.target.value)}
            placeholder="your@email.com" onKeyDown={e=>e.key==="Enter"&&submit()}/></div>
        {err&&<div style={{fontSize:14,color:C.stress}}>{err}</div>}
        <button style={{...BG,opacity:load?0.6:1}} onClick={submit} disabled={load}>
          {load?(lang==="zh"?"发送中…":"Sending…"):(lang==="zh"?"发送重置链接":"SEND RESET LINK")}
        </button>
        <div style={{textAlign:"center",fontSize:14,color:C.mist3}}>
          <span style={{color:C.gold,cursor:"pointer"}} onClick={()=>setPage("login")}>
            {lang==="zh"?"返回登录":"Back to Sign In"}
          </span>
        </div>
      </div>
    </AuthCard>
  );
}

export function ResetPasswordPage({lang="en",setPage,resetToken}){
  const [pw,setPw]=useState("");
  const [pw2,setPw2]=useState("");
  const [done,setDone]=useState(false);
  const [load,setLoad]=useState(false);
  const [err,setErr]=useState("");

  const submit=async()=>{
    if(pw.length<8){setErr(lang==="zh"?"密码至少8位":"Password must be at least 8 characters");return;}
    if(pw!==pw2){setErr(lang==="zh"?"两次密码不一致":"Passwords don't match");return;}
    setLoad(true);setErr("");
    try{
      const r=await fetch(`${API}/auth/reset-password`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({token:resetToken,new_password:pw})
      });
      const d=await r.json();
      if(r.ok)setDone(true);
      else setErr(d.detail||"Error");
    }catch(e){setErr(e.message);}
    setLoad(false);
  };

  if(done)return(
    <AuthCard title={lang==="zh"?"密码已重置":"Password Reset Complete"} sub="">
      <div style={{fontSize:15,color:C.sage,marginBottom:20}}>
        {lang==="zh"?"您的密码已成功重置，请使用新密码登录。":"Your password has been reset successfully. Please sign in with your new password."}
      </div>
      <button style={BG} onClick={()=>setPage("login")}>
        {lang==="zh"?"登录":"SIGN IN"}
      </button>
    </AuthCard>
  );

  return(
    <AuthCard title={lang==="zh"?"设置新密码":"Set New Password"} sub={lang==="zh"?"请输入您的新密码。":"Enter your new password below."}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div><span style={LS}>{lang==="zh"?"新密码":"New Password"}</span>
          <input style={IS} type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="Min 8 characters"/></div>
        <div><span style={LS}>{lang==="zh"?"确认密码":"Confirm Password"}</span>
          <input style={IS} type="password" value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="Re-enter password"
            onKeyDown={e=>e.key==="Enter"&&submit()}/></div>
        {err&&<div style={{fontSize:14,color:C.stress}}>{err}</div>}
        <button style={{...BG,opacity:load?0.6:1}} onClick={submit} disabled={load}>
          {load?(lang==="zh"?"重置中…":"Resetting…"):(lang==="zh"?"重置密码":"RESET PASSWORD")}
        </button>
      </div>
    </AuthCard>
  );
}

// ── Root App ──────────────────────────────────────────────────────────────────
